export const openInvoicePdf = (pdfUrl) => {
  if (!pdfUrl) return;
  window.open(pdfUrl, '_blank', 'noopener,noreferrer');
};
